import React from 'react';
import Breadcrumb from '../../breadcrumb/component.tsx';
import type { BreadcrumbData } from '../../types.tsx';
import { createProjectUrl } from '../common/create-url/index.tsx';
import messages from './messages.tsx';
import type { ProjectBreadcrumbPropsWithIntl } from './types.tsx';

const ProjectBreadcrumb = ({
	isSimplifiedProject,
	children,
	projectKey,
	projectName,
	projectId,
	intl: { formatMessage },
}: ProjectBreadcrumbPropsWithIntl) => {
	const ProjectsBreadcrumb: BreadcrumbData = {
		href: '/jira/projects',
		text: formatMessage(messages.projectsTitle),
		type: 'projectsDirectory',
		analyticsAttributes: {
			nextGenProject: isSimplifiedProject,
			projectConfig:
				isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic',
		},
		analyticsFields: {
			name: 'navigateToProjectsList',
		},
	};

	if (projectKey != null && projectName != null) {
		const breadcrumb: BreadcrumbData = {
			href: createProjectUrl(projectKey),
			text: projectName,
			type: 'projectName',
			analyticsAttributes: {
				nextGenProject: isSimplifiedProject,
				projectConfig:
					isSimplifiedProject !== undefined && isSimplifiedProject === true
						? 'next-gen'
						: 'classic',
			},
			analyticsFields: {
				name: 'navigateToProject',
				containerId: projectId,
				containerType: 'project',
			},
		};
		const ProjectNameBreadcrumb = <Breadcrumb breadcrumb={breadcrumb}>{children}</Breadcrumb>;
		return <Breadcrumb breadcrumb={ProjectsBreadcrumb}>{ProjectNameBreadcrumb}</Breadcrumb>;
	}

	return <Breadcrumb breadcrumb={ProjectsBreadcrumb}>{children}</Breadcrumb>;
};

ProjectBreadcrumb.defaultProps = {
	children: null,
	isSimplifiedProject: false,
	projectId: undefined,
	projectKey: undefined,
	projectName: undefined,
};

export default ProjectBreadcrumb;
